import React, { useState, useEffect, useContext } from "react";
import './rightDetails.scss';
import { FiCalendar } from "react-icons/fi";
import { MdOutlineTransgender, MdDialpad } from "react-icons/md";
import { CiGlobe } from "react-icons/ci";
import { HiOutlineEnvelope, HiOutlineBuildingLibrary } from "react-icons/hi2";
import { FaLinkedinIn } from "react-icons/fa6";
import { Comments } from "./comments";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { AuthContext } from "../../context/AuthContext";
import {
  JobTypeEnumLabels, EmploymentStatusEnumLabels
} from "../../enum/enum";
import { toast } from "react-toastify";

export const PersonalDetails = () => {
  let { id } = useParams();
  const [candidateData, setCandidateData] = useState(null);
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const fetchData = async () => {
    try {
      if (!id){
        id=candidateIdValue;
      }
      const response = await candidateApi.getCandidateById(id); // Call API with the ID
      if (response?.data) {
        setCandidateData(response.data); // Set the data if the response is successful
        console.log("Fetched Data:", response.data);
      }
    } catch (error) {
      toast.error("Error fetching candidate details", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching candidate details:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);

 
    const formatDate = (dateString) => {
      if (!dateString) return ""; // Handle cases where dob is not provided
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    };
   

  return (
    <div className="row">
      {candidateData ? (
        <>
      <div className="col-12 col-md-9 col-lg-9 ">
        <div className="card p-3 mb-4">
          <h6 className="float-title">Basic Details</h6>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="d-flex gap-2 align-items-center mb-3">
                <label className="form-label with-icon mb-0" >
                  <span><FiCalendar /></span>
                  DOB
                </label>
                <p className="mb-0">{formatDate(candidateData.dob)}</p>
              </div>
              <div className="d-flex gap-2 align-items-center mb-3">
                <label className="form-label mb-0 with-icon" >
                  <span><MdOutlineTransgender /></span>
                  Gender
                </label>
                <p className="mb-0">{candidateData.gender}</p>
              </div>
              <div className="d-flex gap-2 align-items-center mb-3">
                <label className="form-label mb-0 with-icon" >
                  <span><CiGlobe /></span>
                  Nationality
                </label>
                <p className="mb-0">{candidateData.nationalityName}</p>
              </div>
              <div className="d-flex gap-2 align-items-center mb-3">
                <label className="form-label mb-0 with-icon" >
                  <span><MdDialpad /></span>
                  Mobile
                </label>
                <p className="mb-0">{candidateData.mobile}</p>
              </div>
              <div className="d-flex gap-2 align-items-center mb-3">
                <label className="form-label mb-0 with-icon" >
                  <span><HiOutlineEnvelope /></span>
                  Email
                </label>
                <p className="mb-0">{candidateData.email}</p>
              </div>
              <div className="d-flex gap-2 align-items-center mb-3">
                <label className="form-label mb-0 with-icon" >
                  <span><FaLinkedinIn /></span>
                  LinkedIn
                </label>
                <p className="mb-0">{candidateData.linkedin}</p>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <h6 className="mb-2">Current Address</h6>
              <p>
              {candidateData.address}
              </p>
              <p>
              {candidateData.city}, {candidateData.stateName}
              </p>
              <p>
              {candidateData.countryName} - {candidateData.pin}
              </p>
            </div>
          </div>
        </div>

        <div className="card p-3 mb-4">
          <h6 className="float-title">Professional Details</h6>
          <div className="row">
            <div className="col-12 col-md-12">
              <label className="form-label mb-0" >

                Qualification
              </label>
              {candidateData.educationTitle && candidateData.educationTitle.length > 0 ? (
                candidateData.educationTitle.map((educationTitle, index) => (
                <p className="mb-0" key={index}>{educationTitle}</p> 
              ))
              ) : (
                <p className="mb-0">No qualification available</p>
              )}
              <hr />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label mb-0" >

                Current Designation
              </label>
              <p className="mb-0">{candidateData.currentDesignation}</p>
              <hr />

            </div>
            <div className="col-12 col-md-4">
              <label className="form-label mb-0" >

                Offered  Designation
              </label>
              <p className="mb-0">{candidateData.offeredDesignation}</p>
              <hr />

            </div>
            <div className="col-12 col-md-4">
              <label className="form-label mb-0" >

                Current Status
              </label>
              <p className="mb-0">{EmploymentStatusEnumLabels[candidateData.employmentStatusId]}</p>
              <hr />

            </div>

            <div className="col-12 col-md-4">
              <label className="form-label mb-0" >

                Notice Period
              </label>
              <p className="mb-0">{candidateData.noticePeriod} Days</p>

            </div>
            <div className="col-12 col-md-4">
              <label className="form-label mb-0" >

                Job Type
              </label>
              {candidateData.jobTypeIds?.length > 0 && (
  <p className="mb-0">
    {candidateData.jobTypeIds.map(type => JobTypeEnumLabels[type]).join(", ")}
  </p>
)}

            </div>
            <div className="col-12 col-md-4">
              <label className="form-label mb-0" >

                Willing to Relocate
              </label>
              <p className="mb-0">{candidateData.willingToRelocate === 1 ? 'Yes' : 'No'}</p>

            </div>

          </div>
        </div>
        <div className="row">

          <div className="col-12 col-md-6 mb-4 ">
            <div className="card p-3 h-100">
              <h6 className="float-title">Source</h6>
              <div className="row">
                <div className="col-12 col-md-6">
                  <label className="form-label mb-0" >
                    {candidateData.jobReferenceSource}
                  </label>
                {/* {['Customer', 'Employee', ].includes(candidateData.jobReferenceSource?.toLowerCase()) && (           */}
                  <p className="mb-0">{candidateData.jobReferenceName}</p>
                {/* )} */}
                </div>
                {/* {['Customer', 'Employee'].includes(candidateData.jobReferenceSource?.toLowerCase()) && (           */}

                <div className="col-12 col-md-6">
                  <label className="form-label mb-0" >
                    Date
                  </label>
                  <p className="mb-0">{formatDate(candidateData.jobReferenceDate)}</p>

                </div>
                {/* )} */}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 mb-4">
            <div className="card p-3 h-100">
              <h6 className="float-title">Company</h6>
              <div className="d-flex gap-2 flex-wrap">
              {candidateData.companyTitle && candidateData.companyTitle.length > 0 ? (
                candidateData.companyTitle.map((companyTitle, index) => (
                  <div className="company-holder d-flex align-items-center gap-2">
                  <span><HiOutlineBuildingLibrary /></span>
                  {companyTitle}
                </div>
                ))
                ) : (
                  <div className="company-holder d-flex align-items-center gap-2">
                  <span><HiOutlineBuildingLibrary /></span>
                  No company available
                </div> 
                )}

              </div>
            </div>
          </div>
        </div>
        <div className="card p-3 ">
              <h6 className="float-title">Notes</h6>
              <p>
                {candidateData.notes}
              </p>
              </div>

      </div>

      <div className="col-12 col-md-3 col-lg-3 ">
        <Comments />
      </div>
      </>
    ) : (
          <p>Loading candidate data...</p> // Loading state when the data is not fetched yet
        )}
    </div>
  );
}

